// import { useEffect, useState, useRef, memo } from "react";
// import * as echarts from "echarts";
// import CustomTooltip from "../Buttons/CustomTooltip";


// const DbMigrationChart = memo(() => {
//   const chartRef = useRef(null);
//   const [error, setError] = useState(null);
//   const containerRef = useRef(null);
//   const socketRef = useRef(null);
//   const retryDelayRef = useRef(1000);
//   const maxRetryDelay = 16000;
//   const [chartData, setChartData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [isFullscreen, setIsFullscreen] = useState(false);
//   const chartInstance = useRef(null);
//   const resizeObserver = useRef(null);

//   useEffect(() => {
//     const connectWebSocket = () => {
//       const authToken = sessionStorage.getItem("access_token");
//       if (!authToken) {
//         console.error("Authentication token missing");
//         setLoading(false);
//         return;
//       }
//       const wsBaseUrlChart = process.env.REACT_APP_API_URL_DATA_MIGRATION;
//       socketRef.current = new WebSocket(
//         `${wsBaseUrlChart}/ws/user-reports?token=${authToken}`
//       );

//       socketRef.current.onopen = () => {
//         console.log("Dashboard chart WebSocket connected");
//         setError(null);
//         setLoading(false);
//         retryDelayRef.current = 1000;
//       };

//       socketRef.current.onmessage = (event) => {
//         try {
//           const message = JSON.parse(event.data);

//           if (message.event === "user_reports_update") {
//             setChartData(message.data);
//           }
//         } catch (err) {
//           console.error("WebSocket message parsing error:", err);
//         }
//       };

//       socketRef.current.onclose = (event) => {
//         console.warn("Dashboard chart WebSocket closed:", event);
//         if (!document.hidden) {
//           if (retryDelayRef.current >= maxRetryDelay) {
//             setError("Connection lost. Retrying...");
//           }
//           setTimeout(connectWebSocket, retryDelayRef.current);
//           retryDelayRef.current = Math.min(retryDelayRef.current * 2, maxRetryDelay);
//         }
//       };

//       socketRef.current.onerror = (err) => {
//         console.error("WebSocket error:", err);
//         socketRef.current?.close();
//       };
//     };

//     const handleVisibilityChange = () => {
//       if (document.hidden && socketRef.current) {
//         socketRef.current.close();
//       } else if (
//         !document.hidden &&
//         (!socketRef.current || socketRef.current.readyState === WebSocket.CLOSED)
//       ) {
//         connectWebSocket();
//       }
//     };

//     document.addEventListener("visibilitychange", handleVisibilityChange);
//     connectWebSocket();

//     return () => {
//       if (socketRef.current) socketRef.current.close();
//       document.removeEventListener("visibilitychange", handleVisibilityChange);
//     };
//   }, []);

//   useEffect(() => {
//     if (!chartRef.current || chartInstance.current || !chartData) return;

//     const initChart = () => {
//       chartInstance.current = echarts.init(chartRef.current);
//       updateChart();
      
//       const resizeHandler = () => {
//         if (chartInstance.current) {
//           chartInstance.current.resize();
//         }
//       };
      
//       window.addEventListener('resize', resizeHandler);
      
//       return () => {
//         window.removeEventListener('resize', resizeHandler);
//         if (chartInstance.current) {
//           chartInstance.current.dispose();
//           chartInstance.current = null;
//         }
//       };
//     };

//     if (chartData.monthly_bar_chart || chartData.monthly_line_chart) {
//       const timer = setTimeout(initChart, 300);
//       return () => clearTimeout(timer);
//     }
//   }, [chartData]);

//   const updateChart = () => {
//     if (chartInstance.current && chartData) {
//       const barData = chartData.monthly_bar_chart || [];
//       const lineData = chartData.monthly_line_chart || [];

//       const allMonths = [
//         ...new Set([
//           ...barData.map(item => item.month),
//           ...lineData.map(item => item.month)
//         ])
//       ].sort();

//       const barDataMap = {};
//       barData.forEach(item => {
//         barDataMap[item.month] = item.job_count;
//       });

//       const lineDataMap = {};
//       lineData.forEach(item => {
//         lineDataMap[item.month] = item.table_count;
//       });

//       const formattedMonths = allMonths.map(month => {
//         const [year, monthNum] = month.split("-");
//         const monthNames = [
//           "Jan", "Feb", "Mar", "Apr", "May", "Jun",
//           "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
//         ];
//         return `${monthNames[parseInt(monthNum, 10) - 1]} '${year.slice(-2)}`;
//       });

//       const jobCounts = allMonths.map(month => barDataMap[month] || 0);
//       const tableCounts = allMonths.map(month => lineDataMap[month] || 0);

//       const option = {
//         grid: {
//           left: "3%",
//           right: "3%",
//           top: "15%",
//           bottom: "3%",
//           containLabel: true,
//         },
//         tooltip: {
//           trigger: "axis",
//           className: "echarts-tooltip",
//           formatter: function(params) {
//             const month = allMonths[params[0].dataIndex];
//             const jobCount = jobCounts[params[0].dataIndex];
//             const tableCount = tableCounts[params[0].dataIndex];
//             return `
//               <div style="font-weight:bold">${month}</div>
//               <div>Job Count: ${jobCount}</div>
//               <div>Table Count: ${tableCount}</div>
//             `;
//           }
//         },
//         legend: {
//           data: ["Job Count", "Table Count"],
//           top: "0",
//           textStyle: {
//             color: '#354258',
//             fontFamily: 'inherit'
//           }
//         },
//         xAxis: {
//           type: "category",
//           data: formattedMonths,
//           axisLine: {
//             lineStyle: {
//               color: '#E4E7EC'
//             }
//           },
//           axisLabel: {
//             color: '#667085'
//           }
//         },
//         yAxis: {
//           type: "value",
//           axisLine: {
//             lineStyle: {
//               color: '#E4E7EC'
//             }
//           },
//           axisLabel: {
//             color: '#667085'
//           },
//           splitLine: {
//             lineStyle: {
//               color: '#F2F4F7'
//             }
//           }
//         },
//         series: [
//           {
//             name: "Job Count",
//             type: "bar",
//             barWidth: "30%",
//             itemStyle: {
//               color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
//                 { offset: 0, color: '#FF8AB9' },
//                 { offset: 1, color: '#DEB1E5' }
//               ]),
//               borderRadius: [2, 2, 0, 0]
//             },
//             emphasis: {
//               itemStyle: {
//                 color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
//                   { offset: 0, color: '#FF6AA9' },
//                   { offset: 1, color: '#D699E5' }
//                 ])
//               }
//             },
//             data: jobCounts,
//           },
//           {
//             name: "Table Count",
//             type: "line",
//             smooth: true,
//             lineStyle: {
//               color: '#354258',
//               width: 2,
//             },
//             areaStyle: {
//               color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
//                 { offset: 0, color: 'rgba(234, 164, 214, 0.3)' },
//                 { offset: 1, color: 'rgba(232, 237, 242, 0.1)' }
//               ])
//             },
//             symbol: "circle",
//             symbolSize: 6,
//             itemStyle: {
//               color: '#354258',
//             },
//             data: tableCounts,
//           },
//         ],
//       };

//       chartInstance.current.setOption(option);
//     }
//   };

//   const handleFullscreen = () => {
//     if (!document.fullscreenElement) {
//       containerRef.current
//         .requestFullscreen()
//         .then(() => {
//           setIsFullscreen(true);
//         })
//         .catch((err) => console.error("Fullscreen error:", err));
//     } else {
//       document
//         .exitFullscreen()
//         .then(() => {
//           setIsFullscreen(false);
//         })
//         .catch((err) => console.error("Exit fullscreen error:", err));
//     }
//   };

//   useEffect(() => {
//     const handleFullscreenChange = () => {
//       const isCurrentlyFullscreen = !!document.fullscreenElement;
//       setIsFullscreen(isCurrentlyFullscreen);
//     };

//     document.addEventListener("fullscreenchange", handleFullscreenChange);
//     return () => {
//       document.removeEventListener("fullscreenchange", handleFullscreenChange);
//     };
//   }, []);

//   return (
//     <div
//       ref={containerRef}
//       className={`card card-migration ${isFullscreen ? "fullscreen-mode" : ""}`}
//       style={{
//         position: "relative",
//         marginLeft: "0px",
//         marginBottom: "2px",
//         display: "flex",
//         flexDirection: "column",
//       }}
//     >
//       <div
//         className="p-3 mb-0"
//         style={{
//           borderRadius: "8px",
//           flex: 1,
//           display: "flex",
//           flexDirection: "column",
//         }}
//       >
//         <div className="d-flex justify-content-between align-items-center">
//           <h6 className="d-flex align-items-center dbcardheadsdesign">
//             <span className="rounded-circle prof me-2">
//               <img
//                 src="assets/images/ConversionTimeline.svg"
//                 style={{ height: "15px", width: "15px", marginBottom: "4px", padding: "2px" }}
//                 alt="Conversion Timeline"
//               />
//             </span>
//             <span>Conversion Timeline</span>
//           </h6>
//           <CustomTooltip
//             content={isFullscreen ? "Exit fullscreen" : "Enter fullscreen"}
//             placement="left"
//             fallbackPlacements={["bottom"]}
//           >
//             <div
//               onClick={handleFullscreen}
//               className="d-flex align-items-center justify-content-center fullscreen"
//               style={{ cursor: "pointer" }}
//             >
//               <i
//                 className={`mdi ${isFullscreen ? "mdi-fullscreen-exit" : "mdi-fullscreen"
//                   } text-dark font-size-22`}
//               />
//             </div>
//           </CustomTooltip>
//         </div>
//         {loading ? (
//           <div
//             className="d-flex justify-content-center align-items-center"
//             style={{
//               flex: 1,
//               minHeight: isFullscreen ? "90vh" : "400px",
//             }}
//           >
//             <div>Loading...</div>
//           </div>
//         ) : !chartData || (!chartData.monthly_bar_chart?.length && !chartData.monthly_line_chart?.length) ? (
//           <div
//             className="d-flex justify-content-center align-items-center"
//             style={{
//               flex: 1,
//               minHeight: isFullscreen ? "90vh" : "400px",
//             }}
//           >
//             <img
//               src="assets/images/emptystate.gif"
//               style={{ width: "300px" }}
//               alt="No Data Available"
//             />
//           </div>
//         ) : (
//           <div
//             ref={chartRef}
//             style={{
//               width: "100%",
//               flex: 1,
//               minHeight: isFullscreen ? "90vh" : "400px",
//             }}
//           />
//         )}
//       </div>
//     </div>
//   );
// });

// export default DbMigrationChart;






















import { useEffect, useState, useRef, memo } from "react";
import * as echarts from "echarts";
import CustomTooltip from "../Buttons/CustomTooltip";

const DbMigrationChart = memo(() => {
  const chartRef = useRef(null);
  const containerRef = useRef(null);
  const socketRef = useRef(null);
  const retryDelayRef = useRef(1000);
  const maxRetryDelay = 16000;
  const [chartData, setChartData] = useState(null);
  const [error, setError] = useState(null);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const chartInstance = useRef(null);

  // WebSocket connection
  useEffect(() => {
    const connectWebSocket = () => {
      const authToken = sessionStorage.getItem("access_token");
      if (!authToken) {
        console.error("Authentication token missing");
        return;
      }
      const wsBaseUrlChart = process.env.REACT_APP_API_URL_DATA_MIGRATION;
      socketRef.current = new WebSocket(
        `${wsBaseUrlChart}/ws/user-reports?token=${authToken}`
      );

      socketRef.current.onopen = () => {
        console.log("Dashboard chart WebSocket connected");
        setError(null);
        retryDelayRef.current = 1000;
      };

      socketRef.current.onmessage = (event) => {
        try {
          const message = JSON.parse(event.data);
          if (message.event === "user_reports_update") {
            setChartData(message.data);
          }
        } catch (err) {
          console.error("WebSocket message parsing error:", err);
        }
      };

      socketRef.current.onclose = (event) => {
        console.warn("Dashboard chart WebSocket closed:", event);
        if (!document.hidden) {
          if (retryDelayRef.current >= maxRetryDelay) {
            setError("Connection lost. Retrying...");
          }
          setTimeout(connectWebSocket, retryDelayRef.current);
          retryDelayRef.current = Math.min(
            retryDelayRef.current * 2,
            maxRetryDelay
          );
        }
      };

      socketRef.current.onerror = (err) => {
        console.error("WebSocket error:", err);
        socketRef.current?.close();
      };
    };

    const handleVisibilityChange = () => {
      if (document.hidden && socketRef.current) {
        socketRef.current.close();
      } else if (
        !document.hidden &&
        (!socketRef.current ||
          socketRef.current.readyState === WebSocket.CLOSED)
      ) {
        connectWebSocket();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    connectWebSocket();

    return () => {
      if (socketRef.current) socketRef.current.close();
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  // Chart init/update
  useEffect(() => {
    if (!chartRef.current || !chartData) return;

    if (!chartInstance.current) {
      chartInstance.current = echarts.init(chartRef.current);
    }
    updateChart();

    const resizeHandler = () => {
      if (chartInstance.current) {
        chartInstance.current.resize();
      }
    };

    window.addEventListener("resize", resizeHandler);

    return () => {
      window.removeEventListener("resize", resizeHandler);
    };
  }, [chartData]);

  

 const updateChart = () => {
  if (!chartInstance.current || !chartData) return;

  const barData = chartData.monthly_bar_chart || [];
  const lineData = chartData.monthly_line_chart || [];

  const allMonths = [
    ...new Set([
      ...barData.map((item) => item.month),
      ...lineData.map((item) => item.month),
    ]),
  ].sort();

  const barDataMap = {};
  barData.forEach((item) => {
    barDataMap[item.month] = item.job_count;
  });

  const lineDataMap = {};
  lineData.forEach((item) => {
    lineDataMap[item.month] = item.table_count;
  });

  const monthNames = [
    "Jan","Feb","Mar","Apr","May","Jun",
    "Jul","Aug","Sep","Oct","Nov","Dec"
  ];

  const formattedMonths = allMonths.map((month) => {
    const [year, monthNum] = month.split("-");
    return `${monthNames[parseInt(monthNum, 10) - 1]} '${year.slice(-2)}`;
  });

  const jobCounts = allMonths.map((month) => barDataMap[month] || 0);
  const tableCounts = allMonths.map((month) => lineDataMap[month] || 0);

  // helper to get CSS vars from container
  const container = containerRef.current;
  const getCssVar = (name, fallback) =>
    getComputedStyle(container).getPropertyValue(name).trim() || fallback;

  const option = {
    grid: {
      left: "3%",
      right: "3%",
      top: "15%",
      bottom: "3%",
      containLabel: true,
    },
    tooltip: {
      trigger: "axis",
      className: "echarts-tooltip",
      formatter: function (params) {
        const month = allMonths[params[0].dataIndex];
        const jobCount = jobCounts[params[0].dataIndex];
        const tableCount = tableCounts[params[0].dataIndex];
        return `
          <div style="font-weight:bold">${month}</div>
          <div>Job Count: ${jobCount}</div>
          <div>Table Count: ${tableCount}</div>
        `;
      },
    },
    legend: {
      data: ["Job Count", "Table Count"],
      top: "0",
      textStyle: {
        color: getCssVar("--chart-axis-color", "#6a6e74ff"),
        fontFamily: "inherit",
      },
    },
    xAxis: {
      type: "category",
      data: formattedMonths,
      axisLine: {
        lineStyle: {
          color: getCssVar("--chart-grid-line", "#E4E7EC"),
        },
      },
      axisLabel: {
        color: getCssVar("--chart-axis-color", "#667085"),
      },
    },
    yAxis: {
      type: "value",
      axisLine: {
        lineStyle: {
          color: getCssVar("--chart-grid-line", "#E4E7EC"),
        },
      },
      axisLabel: {
        color: getCssVar("--chart-axis-color", "#667085"),
      },
      splitLine: {
        lineStyle: {
          color: getCssVar("--chart-grid-line", "#F2F4F7"),
        },
      },
    },
    series: [
      {
        name: "Job Count",
        type: "bar",
        barWidth: "30%",
        itemStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
            { offset: 0, color: getCssVar("--chart-job-bar", "#FF8AB9") },
            { offset: 1, color: getCssVar("--chart-job-bar2", "#DEB1E5") },
          ]),
          borderRadius: [2, 2, 0, 0],
        },
        emphasis: {
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
              { offset: 0, color: getCssVar("--chart-job-bar", "#FF6AA9") },
              { offset: 1, color: getCssVar("--chart-job-bar2", "#D699E5") },
            ]),
          },
        },
        data: jobCounts,
      },
      {
        name: "Table Count",
        type: "line",
        smooth: true,
        lineStyle: {
          color: getCssVar("--chart-table-line", "#354258"),
          width: 2,
        },
        areaStyle: {
          color: getCssVar(
            "--chart-table-fill",
            "rgba(234, 164, 214, 0.3)"
          ),
        },
        symbol: "circle",
        symbolSize: 6,
        itemStyle: {
          color: getCssVar("--chart-table-line", "#354258"),
        },
        data: tableCounts,
      },
    ],
  };

  chartInstance.current.setOption(option);
};

  const handleFullscreen = () => {
    if (!document.fullscreenElement) {
      containerRef.current
        .requestFullscreen()
        .then(() => setIsFullscreen(true))
        .catch((err) => console.error("Fullscreen error:", err));
    } else {
      document
        .exitFullscreen()
        .then(() => setIsFullscreen(false))
        .catch((err) => console.error("Exit fullscreen error:", err));
    }
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };
    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);

  const hasData =
    chartData &&
    (chartData.monthly_bar_chart?.length ||
      chartData.monthly_line_chart?.length);

  return (
    <div
      ref={containerRef}
      className={`card card-migration ${isFullscreen ? "fullscreen-mode" : ""}`}
      style={{
        position: "relative",
        marginLeft: "0px",
        marginBottom: "2px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        className="p-3 mb-0"
        style={{
          borderRadius: "8px",
          flex: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div className="d-flex justify-content-between align-items-center">
          <h6 className="d-flex align-items-center dbcardheadsdesign">
            
              <div class="icons-bg me-2"><i class="dash-icon-data-migration"></i></div>
           
            <span style={{marginLeft:"6px"}} >Data Migration Timeline </span>
          </h6>
          <CustomTooltip
            content={isFullscreen ? "Exit fullscreen" : "Enter fullscreen"}
            placement="left"
            fallbackPlacements={["bottom"]}
          >
            <div
              onClick={handleFullscreen}
              className="d-flex align-items-center justify-content-center fullscreen"
              style={{ cursor: "pointer" }}
            >
              <i
                className={`mdi ${
                  isFullscreen ? "mdi-fullscreen-exit" : "mdi-fullscreen"
                } text-dark font-size-22`}
              />
            </div>
          </CustomTooltip>
        </div>

        {/* GIF or Chart */}
        {!hasData ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{
              flex: 1,
              minHeight: isFullscreen ? "90vh" : "400px",
             
              flexDirection:"column"
            }}
          >
            <img
              src="assets/images/emptystate.gif"
              style={{ width: "300px" }}
              alt="No Data Available"
            />
               <div className="text-muted mt-2">
                No migration data available
              </div>
          </div>
        ) : (
          <div
            ref={chartRef}
            style={{
              width: "100%",
              flex: 1,
              minHeight: isFullscreen ? "90vh" : "400px",
            }}
          />
        )}
      </div>
    </div>
  );
});

export default DbMigrationChart;
